import { Box, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import signPic1 from "../assets/image/audience.png";
import DownArrow from "../assets/SVG/downArrow";
import Group from "../assets/SVG/group";
import ProfileIcon from "../assets/SVG/profileIcon";
import UserIcon from "../assets/SVG/userIcon";
import UsersIcon from "../assets/SVG/usersIcon";
import Vector from "../assets/SVG/vector";
import CardImageSignin from "../components/signin/cardImageSignin";
import logo from "../assets/image/logo.png";

export function CardBlueOr({ children, text,href }) {
  return (
    <Link to={href} >
    <Box
      sx={{
        width: "237px",
        height: "172px",
        borderRadius: "20px",
        border: "2px solid #42C3CF",
        display: "grid",
        justifyItems: "center",
        cursor: "pointer",
        "&:hover": {
          bgcolor: "#ebf3ff",
          transition: "0.2s all",
        },
      }}
      >
      {children}
      <Typography color="#42C3CF">{text}</Typography>
    </Box>
      </Link>
  );
}
export default function Signin() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="left"
      style={{
        background: "linear-gradient(180deg, #6cbbc7 0%, #6cbbc7 100%)",
      }}
      width="100vw"
      height="100vh"
      position="fixed"
    >
      <Box  width="100%">
        <Box m="30px" mt="-20px" >
        <img style={{width:"80px",height:"auto"}} src={logo} />
        </Box>
        <CardImageSignin
          image={signPic1}
          title="ثبت نام"
          text="لطفاً اطلاعات خود را برای ثبت نام به عنوان جهادگر یا درخواست استفاده از نرم‌افزار برای گروه خود وارد کنید."
        />
      </Box>
      <Box className="cardLogin" bgcolor="white" ml="14px">
        <Box display='flex'  justifyContent='left' >
          <Link to='/login' >
            <Box sx={{cursor:'pointer'}} width="fit-content" m='30px 40px' >
                <Vector />
            </Box>
          </Link>
        </Box>
        <Box height="80%" display="grid" alignContent='center' >
          <Box
            alignItems="center"
            gap="40px"
            display={"flex"}
            justifyContent="center"
          >
            
            <CardBlueOr href={`group`}  text="ثبت نام گروه جهادی">
              <UsersIcon />
            </CardBlueOr>
            <CardBlueOr href={`mujahid`}  text="ثبت نام جهادگر">
              <UserIcon />
            </CardBlueOr>
          </Box>
          <Box display="flex" justifyContent="center" mt="50px">
            <Typography sx={{ fontSize: "16px", color: "#414F4Ds" }}>
            حساب کاربری دارید؟ 
            </Typography>
            <Link to="/login">
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "#6CBBC7",
                  mr: "5px",
                  cursor: "pointer",
                }}
              >
                 وارد شوید.
              </Typography>
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
